import { DropDownList } from "../core/components/dropDownList";
import { Dialog, DialogProps } from "../core/components/dialog";
import { StyleHelper } from "./style";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { Grid } from "../core/components/grid";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { General } from "../../siteManagement/general";
import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Context, Entity, Metadata } from "../core/components/commonApp";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { ComponentHelper } from "../core/util/componentHelper";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export default class EditStyles extends React.Component<EditStylesProps, EditStylesState>{
    private translations: StringKeyDictionary<string>;
    private gridOptions: kendo.ui.GridOptions;
    private metaData: Metadata;
    private deprecatedStyles: any[];

    constructor(props: EditStylesProps) {
        super(props);
        this.state = {
            gridData: [],
            selected: null
        }
        this.initApp();
    }

    private initApp = async () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Name",
                    title: Helper.getTranslation("Standard.Name")
                },
                this.getColumn("PrimaryColor"),
                this.getColumn("PrimaryColorLight"),
                this.getColumn("SecondaryColor"),
                this.getColumn("SecondaryColorLight"),
                {
                    field: "IsActive",
                    title: Helper.getTranslation("WebSMS.GeneralSettings.Style.IsActivated"),
                    template: "# if(data.IsActive) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#",
                }
            ]
        };
        const [metaData, deprecatedStyles, _] = await Promise.all([
            Helper.getMetaData("editStyle"),
            this.getDeprecatedStyles(),
            this.loadGridData()
        ]);
        this.metaData = metaData;
        this.deprecatedStyles = deprecatedStyles;
        this.setState({})
    }

    private getDeprecatedStyles = async () => {
        const result = await HTTPService.get<JsonResultClass<any[]>>("Style/GetDeprecatedStyles");
        if (result.Code == 0) {
            return result.Data;
        } else {
            return [];
        }
    }

    private getColumn = (field: string) => {
        return {
            field: field,
            title: Helper.getTranslation("WebSMS.GeneralSettings.Style." + field),
            template: (item) => {
                return `<div data-color="${item[field]}">${item[field]}</div>`
            }
        }
    }


    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass<Style[]>>("Style/GetStyles");
        this.setState({ gridData: result.Data })
    }
    private createGrid = () => {
        if (Helper.hasValue(this.gridOptions)) {
            const standardButtons: Array<ToolBarStandardButton> = [
                {
                    caption: Config.translations.newLabel,
                    enabled: true,
                    type: ToolBarStandardButtonType.NEW
                },
                {
                    caption: Config.translations.editLabel,
                    enabled: true,
                    type: ToolBarStandardButtonType.EDIT
                },
                {
                    caption: Config.translations.deleteLabel,
                    enabled: Helper.hasValue(this.state.selected) && !this.state.selected.IsActive,
                    type: ToolBarStandardButtonType.DELETE
                }
            ];
            const customButtons: Array<GridCustomToolBarButton> = [
                {
                    autoEnabledOnRecordSelected: true,
                    caption: Helper.getTranslation("Server.Settings.Activate"),
                    enabled: Helper.hasValue(this.state.selected) && !this.state.selected.IsActive,
                    iconClass: "k-i-check",
                    id: "activate"
                },
                {
                    autoEnabledOnRecordSelected: false,
                    caption: Helper.getTranslation("WebSMS.GeneralSettings.Style.DetermineColours"),
                    enabled: true,
                    iconClass: "k-i-calculator",
                    id: "getByLogo"
                }
            ];
            if (Helper.hasValue(this.deprecatedStyles) && this.deprecatedStyles.length > 0) {
                customButtons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: Helper.getTranslation("WebSMS.GeneralSettings.Style.Migrate"),
                    enabled: true,
                    iconClass: "k-i-redo",
                    id: "migrate"
                });
            }
            return (
                <div className="flex-container">
                    <Grid
                        data={this.state.gridData}
                        options={this.gridOptions}
                        standardButtons={standardButtons}
                        onClickStandardButton={this.onStandardClick}
                        onClickCustomButton={this.onCustomClick}
                        customButtons={customButtons}
                        onSelectionChanged={this.onSelectionsChanged}
                        id="editStyles"
                        onDataBound={this.onDataBound}
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    private onDataBound = (event: kendo.ui.GridDataBoundEvent) => {
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {

            const row = event.sender.tbody.find(`tr[data-uid='${data[i].uid}']`);
            const containers = row.find("div");
            for (let j = 0; j < containers.length; j++) {
                const container = containers[j];
                const color = container.getAttribute("data-color")
                if (!Helper.isNullOrEmpty(color)) {
                    container.style.backgroundColor = color;
                    container.style.color = StyleHelper.getFontColor(color);
                    container.style.height = "30px";
                    container.style.padding = "3px 7px";
                    container.style.display = "flex";
                    container.style.alignItems = "center";
                    container.style.justifyContent = "center";
                }
            }

        }
    }

    private onStandardClick = (type: ToolBarStandardButtonType, dataItem: Style) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.openWindow(null, true);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.openWindow(dataItem, false)
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem.Id).then(() => {
                    this.loadGridData();
                })
                break;
        }
    }

    private openWindow = (dataItem: Style, isNew: boolean) => {
        let entity: StyleEntity;
        if (Helper.hasValue(dataItem)) {
            entity = {
                Id: dataItem.Id,
                IsActive: dataItem.IsActive,
                IsNew: isNew,
                IsWatchable: false,
                IsWatched: false,
                Name: dataItem.Name,
                Note: dataItem.Note,
                PrimaryColor: dataItem.PrimaryColor,
                PrimaryColorLight: dataItem.PrimaryColorLight,
                SecondaryColor: dataItem.SecondaryColor,
                SecondaryColorLight: dataItem.SecondaryColorLight,
                BorderRadius: dataItem.BorderRadius,
                RecordRight: {
                    CanRead: true, 
                    CanWrite: true
                },
                IndividualFields: {}
            }
        } else {
            entity = {
                Id: kendo.guid(),
                IsActive: false,
                IsNew: true,
                Name: "",
                Note: "",
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false,
                BorderRadius: "0.375rem",
                PrimaryColor: "#CC3467",
                PrimaryColorLight: "#CC346740",
                SecondaryColor: "#B42E5A",
                SecondaryColorLight: "#B42E5A40"
            }
        }
        const props: EditStyleProps = {
            context: {
                contextType: "EditStyle"
            },
            dataSources: {},
            entity: entity,
            isWindow: true,
            title: entity.Name,
            metadata: this.metaData,
            activate: this.activate,
            delete: this.delete
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(EditStyle, props);
        });
        sheet.bind(SheetEventType.Close, () => {
            this.loadGridData()
        });
    }

    private delete = async (id: string) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            const result = await HTTPService.get<JsonResultClass>("Style/Delete?id=" + id);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message)
            } else {
                NotificationHelper.showErrorMessage(result.Message)
            }
        }
        return isOk;
    }

    private onCustomClick = async (id: string, dataItem: Style) => {
        switch (id) {
            case "activate":
                await this.activate(dataItem.Id);
                location.reload();
                break;
            case "getByLogo":
                const result = await HTTPService.get<JsonResultClass<string>>("Style/GetByLogo")
                if (result.Code == 0) {
                    const style = this.getStyleFromColor(result.Data);
                    this.openWindow(style, true);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                break;
            case "migrate":
                const style = await this.getStyleForMigration();
                if (Helper.hasValue(style)) {
                    this.openWindow(style, true)
                }
                break;
        }
    }

    private getStyleFromColor = (primaryColor: string): Style => {
        const blackened = (x: number) => {
            const tmp = (8 * x) / 10;
            return Math.floor(tmp);
        }


        const color = StyleHelper.hexToRgba(primaryColor);
        color.r = blackened(color.r);
        color.g = blackened(color.g);
        color.b = blackened(color.b);
        const secondary = StyleHelper.rgbaToHex(color);
        return {
            BorderRadius: "0.38rem",
            Id: kendo.guid(),
            IsActive: false,
            PrimaryColor: primaryColor,
            PrimaryColorLight: `${primaryColor}40`,
            SecondaryColor: secondary,
            SecondaryColorLight: `${secondary}40`,
            Name: null,
            Note: null
        }
    }

    private getStyleForMigration = () => {
        return new Promise<Style>(async (resolve) => {
            let style: any;
            switch (this.deprecatedStyles.length) {
                case 0:
                    resolve(null);
                    break;
                case 1:
                    style = this.deprecatedStyles[0];
                    break;
                default:
                    style = await this.getDepricatedStyle();
                    break;
            }
            const tmp = this.getStyleFromColor(style.PrimaryColor);
            tmp.Name = style.Name;
            tmp.Note = style.Note;
            resolve(tmp)
        });
    }

    private getDepricatedStyle = () => {
        return new Promise<Style>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            const root = ReactDOM["createRoot"](targetElement[0]);
            const dialogProps: DialogProps = {
                title: Helper.getTranslation("Standard.Auswählen"),
                actions: [
                    {
                        action: () => {
                            resolve(null)
                        },
                        label: Helper.getTranslation("Standard.CloseBtn"),
                        primary: false
                    }, {
                        action: () => {
                            resolve(selected)
                        },
                        label: Helper.getTranslation("Standard.Auswählen"),
                        primary: true
                    }

                ],
                open: true,
                width: 600
            };
            var selected = this.deprecatedStyles[0];
            const dropDownProps = ComponentHelper.createFactory().getDefaultDropDownProps();
            dropDownProps.dataSource = this.deprecatedStyles;
            dropDownProps.field.dataValueField = "Name";
            dropDownProps.field.dataTextField = "Name";
            dropDownProps.field.optionLabel = "";
            dropDownProps.value = selected;
            dropDownProps.field.listWidth = 600;
            dropDownProps.onChange = (_, __, dataItem) => {
                selected = dataItem;
            }
            root.render(
                <>
                    <Dialog {...dialogProps}>
                        <DropDownList {...dropDownProps} />
                    </Dialog>
                </>);

        });
    }

    private activate = (id: string) => {
        return new Promise<boolean>(async (resolve) => {
            const result = await HTTPService.get<JsonResultClass>("Style/Activate?id=" + id);
            if (result.AdditionalData.customFileCreated) {
                NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.GeneralSettings.Style.ApplicationRestarted"));
                setTimeout(() => {
                    document.getElementById('logout-form__trigger').click();
                    resolve(false);
                }, 1000);
            } else {
                if (result.Code == 0) {
                    NotificationHelper.showSuccessMessage(result.Message)
                } else {
                    NotificationHelper.showErrorMessage(result.Message)
                }
                setTimeout(() => {
                    resolve(result.Code == 0)
                }, 500);
            }
        })
    }

    private onSelectionsChanged = (dataItem: Style) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ selected: dataItem })
        }
    }

    render() {
        return this.createGrid();
    }
}

interface EditStylesProps extends BaseComponentProps {
    context: Context
}

interface Style {
    Id: string,
    Name: string,
    Note: string,
    IsActive: boolean,
    PrimaryColor: string,
    PrimaryColorLight: string,
    SecondaryColor: string,
    SecondaryColorLight: string
    BorderRadius: string;
}

interface EditStylesState {
    gridData: Style[];
    selected: Style

}

class EditStyle extends React.Component<EditStyleProps, any>{
    private factory = ComponentHelper.createFactory();
    private common = new AppHelper();
    private sheet: Sheet;
    constructor(props) {
        super(props);
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet()
    }

    activate = async () => {
        const success = await this.props.activate(this.props.entity.Id)
        if (success) {
            location.reload();
        }
    }

    remove = async () => {
        const success = await this.props.delete(this.props.entity.Id)
        if (success)
            this.sheet.hide();
    }

    save = async () => {
        const success = await this.saveInternal();
        if (this.props.entity.IsActive && success) {
            this.activate()
        }
    }

    saveAndActivate = async () => {
        const success = await this.saveInternal();
        if (success)
            this.activate();
    }

    private saveInternal = async () => {
        if (this.common.validate()) {
            let result = await HTTPService.post<JsonResultClass<Style>>("Style/Save", { model: this.props.entity });
            if (result.Code === 0) {
                Helper.updateEntity(this.props.entity, result.Data);
                this.common.updateSheetTitle(this.props.entity.Name);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, false);
            this.setState({});
            return result.Code == 0;
        } else {
            return false;
        }
    }

    renderBorderRadiusField = () => {

        const onChange = (value) => {
            this.handleFieldChange({model: "entity.BorderRadius"}, value)
        }

        const valuePattern = /[0-9.]+/;
        const unitPattern = /(px|rem|em)/;

        const value = valuePattern.exec(this.props.entity.BorderRadius)[0];
        const unit = unitPattern.exec(this.props.entity.BorderRadius)[0];

        const valueProps = this.factory.getDefaultNumericTextBoxProps();
        valueProps.value = parseFloat(value);
        valueProps.onChange = (_, value: number) => {
            onChange(`${value}${unit}`);
        }
        valueProps.field.min = 0;
        valueProps.field.format = "n2"


        const unitProps = this.factory.getDefaultDropDownProps();
        unitProps.value = unit;
        unitProps.onChange = (_, unit: string) => {
            onChange(`${value}${unit}`);
        }
        unitProps.dataSource = [
            "px", "em", "rem"
        ].map(v => { return { text: v, value: v } });
        unitProps.field.dataTextField = 'text';
        unitProps.field.dataValueField = 'value';
        unitProps.field.optionLabel = '';

        return (
            <div style={{ display: "flex" }} >
                <div style={{ width: "150px", marginRight: "5px" }} >
                    <IsNumericTextBox {...valueProps} />
                </div>
                <div style={{ width: "150px" }}>
                    <DropDownList {...unitProps} />
                </div>
                {this.renderUnitInfo()}
            </div>
        );
    }

    private renderUnitInfo = () => {
        return (
            <>
                <style>
                    {
                        `
                        .unit_info{
                            border-radius: 50%;
                            border: 2px solid #0d47a1;
                            color: #0d47a1;
                            height: 30px;
                            width: 30px;
                            margin: 5px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 1.4em;
                            position: relative;
                        }

                        @keyframes unit_info_fade{
                            from {
                                background-color: #ffffff;
                                color: #0d47a1;
                            }

                            to {
                                color: #ffffff;
                                background-color: #0d47a1;
                            }
                        }
                        
                        .unit_info:hover{
                            color: #ffffff;
                            background-color: #0d47a1;
                            cursor: help;
                            animation-name: unit_info_fade;
                            animation-duration: .4s;
                        }

                        @keyframes unit_info__info_box_fade{
                            from {
                                opacity: 0;
                            }

                            to {
                                opacity: 1;
                            }
                        }

                        .unit_info__info_box{
                            opacity: 0;
                            width: 450px;
                            z-index: 2;
                            position: absolute;
                            top: 30px;
                            left: 0;
                            display: none;
                            border-radius: var(--border-radius);
                            background-color: white;
                            border: 1px solid rgb(222, 226, 230);
                            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);
                            color: black;
                            font-size: 0.75em;
                            padding: 10px;
                        }

                        .unit_info:hover .unit_info__info_box{
                            display: flex;
                            flex-direction: column;
                            animation-name: unit_info__info_box_fade;
                            opacity: 1;
                            animation-duration: .4s;
                        }

                        .unit_info__info_box span{ line-height: 1.5em; margin: 0 0 12px 0}

                        `
                    }
                </style>
                <div style={{ height: "40px", width: "40px" }} >
                    <div className="unit_info">
                        ?
                        <div className="unit_info__info_box" >
                            <span>Die Eigenschaft rundet die Ecken von verschiedenen Elementen im FSM (z.B. Eingabeelemente oder Menükacheln) ab</span>
                            <span>px = Stellt eine absolute Größe am Bildschirm dar</span>
                            <span>em = Eine relative Einheit. Ein em entspricht 100% der Schriftgröße der Schrift des Eltern Elements</span>
                            <span>rem = Eine relative Einheit. Ein rem entspricht 100% der Schriftgröße des Root Basis Font</span>
                        </div>
                    </div>
                </div>
                
            </>
        )
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (field.type == "kendo-color-picker" && (value as string).includes("rgba")) {
            value = this.rgba2hex(value);
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private rgba2hex = (orig) => {
        let a,
            rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
            alpha = (rgb && rgb[4] || "").trim(),
            hex = rgb ?
                (rgb[1] | 1 << 8).toString(16).slice(1) +
                (rgb[2] | 1 << 8).toString(16).slice(1) +
                (rgb[3] | 1 << 8).toString(16).slice(1) : orig;

        if (alpha !== "") {
            a = alpha;
        } else {
            a = 0o1;
        }
        // multiply before convert to HEX
        a = ((a * 255) | 1 << 8).toString(16).slice(1)
        hex = hex + a;

        return "#" + hex;
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.isNullOrEmpty(this.props.title) ? Helper.getTranslation("WebSMS.GeneralSettings.Style.NewStyle") : this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditStyleProps extends AppBaseProps {
    entity: StyleEntity;
    activate: (id: string) => Promise<boolean>
    delete: (id: string) => Promise<boolean>
}

interface StyleEntity extends Entity, Style {


}